'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { ERROR_MESSAGE } from './_components/DatadogErrorBoundary';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    try {
      datadogRum.addError(error, {
        source: 'global-error-boundary',
        digest: error.digest,
      });
    } catch (e) {
      console.warn('Failed to report error to Datadog RUM:', e);
    }
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'sans-serif',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <h2>{ERROR_MESSAGE}</h2>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: '16px', padding: '8px 24px', cursor: 'pointer' }}
          >
            Reload page
          </button>
        </div>
      </body>
    </html>
  );
}
